// extracted by mini-css-extract-plugin
export default {"root":"Popup_root__ZHFTz","content":"Popup_content__zuFTO","footer":"Popup_footer__ztzPB","closeButton":"Popup_closeButton__whshd","header":"Popup_header__aYh4Z"};